import { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'

import { creerSelle, lireSelle, majSelle, supprimerSelle } from '../../db/repo'
import { fromDatetimeLocalValue, nowInstant, toDatetimeLocalValue } from '../../domain/time'
import {
  BRISTOLS,
  BRISTOL_COURT,
  BRISTOL_LABELS,
  DOULEUR_DEFECATION_MIN,
  type Bristol,
} from '../../domain/types'
import { BoutonSupprimer, Carte, Champ, Curseur, Entete } from '../composants'

export function PageSelle() {
  const { id } = useParams()
  const navigate = useNavigate()
  const edition = Boolean(id)

  const [at, setAt] = useState(() => toDatetimeLocalValue(nowInstant()))
  const [bristol, setBristol] = useState<Bristol>(4)
  const [urgence, setUrgence] = useState(false)
  const [incomplete, setIncomplete] = useState(false)
  const [douleur, setDouleur] = useState(0)
  const [notes, setNotes] = useState('')

  useEffect(() => {
    if (!id) return
    void lireSelle(id).then((s) => {
      if (!s) return
      setAt(toDatetimeLocalValue(s.at))
      setBristol(s.bristol)
      setUrgence(s.urgence)
      setIncomplete(s.evacuationIncomplete ?? false)
      setDouleur(s.douleur ?? 0)
      setNotes(s.notes ?? '')
    })
  }, [id])

  const enregistrer = async () => {
    const data = {
      at: fromDatetimeLocalValue(at),
      bristol,
      urgence,
      ...(incomplete ? { evacuationIncomplete: true } : {}),
      ...(douleur > 0 ? { douleur } : {}),
      ...(notes.trim() ? { notes: notes.trim() } : {}),
    }
    if (id) await majSelle(id, data)
    else await creerSelle(data)
    navigate(-1)
  }

  return (
    <>
      <Entete titre={edition ? 'Modifier le passage' : 'Passage aux selles'} retour />

      <main className="contenu">
        <Carte titre="Quand">
          <Champ label="Moment">
            <input type="datetime-local" value={at} onChange={(e) => setAt(e.target.value)} />
          </Champ>
        </Carte>

        <Carte titre="Consistance (échelle de Bristol)">
          <div className="puces">
            {BRISTOLS.map((b) => (
              <button
                key={b}
                type="button"
                className="choix"
                aria-pressed={bristol === b}
                onClick={() => setBristol(b)}
                title={BRISTOL_LABELS[b]}
              >
                {b} · {BRISTOL_COURT[b]}
              </button>
            ))}
          </div>
          <p className="tres-doux" style={{ marginTop: 9 }}>
            {BRISTOL_LABELS[bristol]}
          </p>
          <p className="champ__aide" style={{ marginTop: 6 }}>
            Les niveaux 6 et 7 sont analysés comme selles molles, les niveaux 1 et 2 comme selles
            dures. Le niveau 4 est la référence normale.
          </p>
        </Carte>

        <Carte titre="Caractéristiques">
          <div className="puces">
            <button
              type="button"
              className="choix"
              aria-pressed={urgence}
              onClick={() => setUrgence((v) => !v)}
            >
              Urgence (impossible à différer)
            </button>
            <button
              type="button"
              className="choix"
              aria-pressed={incomplete}
              onClick={() => setIncomplete((v) => !v)}
            >
              Évacuation incomplète
            </button>
          </div>

          <div style={{ marginTop: 14 }}>
            <Curseur
              label="Douleur à la défécation"
              valeur={douleur}
              onChange={setDouleur}
              suffixe="/10"
              aide={`Analysée comme événement à partir de ${DOULEUR_DEFECATION_MIN}/10. Laissez à 0 s'il n'y en a pas.`}
            />
          </div>
        </Carte>

        <Carte>
          <Champ label="Notes (facultatif)">
            <textarea value={notes} onChange={(e) => setNotes(e.target.value)} />
          </Champ>
        </Carte>

        <button
          type="button"
          className="btn btn--principal btn--large"
          onClick={() => void enregistrer()}
        >
          Enregistrer
        </button>

        {id && (
          <BoutonSupprimer
            titre="Supprimer ce passage ?"
            message="Il sera définitivement retiré du journal, du comptage quotidien et des analyses."
            onSupprimer={() => {
              void supprimerSelle(id).then(() => navigate('/journal'))
            }}
          />
        )}
      </main>
    </>
  )
}
